import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MoreMenuMobileSettingsModel } from './more-menu-mobile-settings.model';

@Component({
    selector: 'fi-more-menu-mobile',
    templateUrl: './more-menu-mobile.component.html',
    styleUrls: ['./more-menu-mobile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class MoreMenuMobileComponent implements OnInit {
    @Input() settings: MoreMenuMobileSettingsModel;

    constructor() {}

    ngOnInit() {}

    onClick(item) {
        item.action();
        return false;
    }
}
